import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import adminUser from './modules/adminUser'
import dressing from './modules/dressing'

const store = createStore({
  modules: { adminUser, dressing },
  plugins: [
    createPersistedState({
      paths: ['adminUser', 'dressing'],
    }),
  ],
})

export default store
